#import "../fragments/products-mutation-fragment.graphql"

mutation RemoveProductForLead($input: LeadProductRemoveInput!) {
    leadProductRemove(input: $input) {
        lead {
            ...ProductMutationFragment
        }
    }
}
